import React from "react";
import ThemeBtn from "../../components/ThemeBtn/ThemeBtn";
import { useNavigate } from "react-router-dom";
import "./AdminLandingPage.scss";

function AdminLandingPage() {
  const navigate = useNavigate();

  return (
      <div className="container-landing admin_landingpage">


          <section className="Register_page">
              <div class="row">
                  <h2 class="form_heading inner_header_main">Admin Dashboard</h2>
              </div>
              <div class="row ">
                  <div class="column">
                      <div class="card">
                          <div class="icon-wrapper">
                              <i class="ri-service-line"></i>
                          </div>
                          <h3>Partnere</h3>
                          <p class="custombt"
                              onClick={() => {
                                  navigate("/legge-til-partner");
                              }}
                          
                          >Legg til</p>

                          <p class="custombt"
                              onClick={() => {
                                  navigate("/partner-dashbordet");
                              }}

                          >Rediger</p>


                          <p class="custombt"
                              onClick={() => {
                                  navigate("/partner-dashbordet");
                              }}

                          >Se alle</p>

                      </div>
                  </div>
                  <div class="column">
                      <div class="card">
                          <div class="icon-wrapper">
                              <i class="ri-archive-line"></i>
                          </div>
                          <h3>Aktiviteter</h3>
                          <p class="custombt"
                              onClick={() => {
                                  navigate("/add-aktivitet");
                              }}

                          >Legg til</p>

                          <p class="custombt"
                              onClick={() => {
                                  navigate("/aktivitet-side");
                              }}

                          >Rediger</p>


                          <p class="custombt"
                              onClick={() => {
                                  navigate("/aktivitet-side");
                              }}

                          >Se alle</p>
                      </div>
                  </div>
                  <div class="column">
                      <div class="card">
                          <div class="icon-wrapper">
                              <i class="ri-file-list-line"></i>
                          </div>
                          <h3>Sammendrag</h3>
                          <p
                              className="custombt"
                              onClick={() => {
                                  navigate("/rekkefølge");
                              }}
                          >
                              Salg historikk
                          </p>

                          <p
                              className="custombt"
                              onClick={() => {
                                  navigate("/unike-koder");
                              }}
                          >
                              Unike koder
                          </p>

                          <p
                              className="custombt"
                              onClick={() => {
                                  alert("No Google Analytics embedded");
                              }}
                          >
                              Besøksdata
                          </p>
                      </div>
                  </div>
                  <div class="column">
                      <div class="card">
                          <div class="icon-wrapper">
                              <i class="ri-heart-2-line"></i>
                          </div>
                          <h3>Nettsiden</h3>
                          <p
                              className="custombt"
                              onClick={() => {
                                  navigate("/søke");
                              }}
                          >
                              Kategori favoritter
                          </p>
                          <p
                              className="custombt"
                              onClick={() => {
                                  navigate("/aktivitet-side?filter=favoritter");
                              }}
                          >
                              ⁠Gavetips favoritter
                          </p>
                          <p
                              className="custombt"
                              onClick={() => {
                                  navigate("/kuponger");
                              }}
                          >
                              Kuponger
                          </p>
                      </div>
                  </div>
                  <div class="column">
                      <div class="card">
                          <div class="icon-wrapper">
                              <i class="ri-community-line"></i>
                          </div>
                          <h3>Bedriftskunder</h3>
                          <p
                              className="custombt"
                              onClick={() => {
                                  navigate("/legge-til-bedriftskunde");
                              }}
                          >
                              Legg til
                          </p>

                          <p
                              className="custombt"
                              onClick={() => {
                                  navigate("/partner-dashbordet2");
                              }}
                          >
                              Redigere
                          </p>


                          <p
                              className="custombt"
                              onClick={() => {
                                  navigate("/bestilllagre");
                              }}
                          >
                              Se lagrede aktiviteter
                          </p>


                          <p
                              className="custombt"
                              onClick={() => {
                                  navigate("/bestillingsdetaljeradmin");
                              }}
                          >
                              Se forespurte bookinger

                          </p>

                      </div>
                  </div>
                  <div class="column">
                      <div class="card">
                          <div class="icon-wrapper">
                              <i class="ri-hammer-line"></i>
                          </div>
                          <h3>Verktøy</h3>
                          {/*<p
    className="custombt"
    onClick={() => {
        navigate("/utility-dashbaord");
    }}
>
    Automatiser jobber
</p>*/}

                          <p
                              className="custombt"
                              onClick={() => {
                                  navigate("/hangfire-jobber");
                              }}
                          >
                              Automatiser jobber
                          </p>

                          <p
                              className="custombt"
                              onClick={() => {
                                  navigate("search/EmailJobManager");
                              }}
                          >
                              E-posthistorikk
                          </p>
                      </div>
                  </div>
              </div>
          </section>


      {/*<h1 className="text-center admin_heading">Admin Dashboard</h1>*/}
      {/*<div className="body-landing">*/}
      {/*  <div className="item-landing">*/}
      {/*    <h2 className="text-center card_heading">Partnere</h2>*/}
      {/*    <ThemeBtn*/}
      {/*      onClick={() => {*/}
      {/*        navigate("/legge-til-partner");*/}
      {/*      }}*/}
      {/*      BtnClass="Theme_btn_primary "*/}
      {/*      BtnText="Legg til"*/}
      {/*    />*/}
      {/*    <ThemeBtn*/}
      {/*      onClick={() => {*/}
      {/*        navigate("/partner-dashbordet");*/}
      {/*      }}*/}
      {/*      BtnClass="Theme_btn_primary "*/}
      {/*      BtnText="Rediger"*/}
      {/*    />*/}
      {/*    <ThemeBtn*/}
      {/*      onClick={() => {*/}
      {/*        navigate("/partner-dashbordet");*/}
      {/*      }}*/}
      {/*      BtnClass="Theme_btn_primary "*/}
      {/*      BtnText="Se alle"*/}
      {/*    />*/}
      {/*  </div>*/}
      {/*  <div className="item-landing">*/}
      {/*    <h2 className="text-center card_heading">Aktiviteter</h2>*/}
      {/*    <ThemeBtn*/}
      {/*      onClick={() => {*/}
      {/*        navigate("/add-aktivitet");*/}
      {/*      }}*/}
      {/*      BtnClass="Theme_btn_primary "*/}
      {/*      BtnText="Legg til"*/}
      {/*    />*/}
      {/*    <ThemeBtn*/}
      {/*      onClick={() => {*/}
      {/*        navigate("/aktivitet-side");*/}
      {/*      }}*/}
      {/*      BtnClass="Theme_btn_primary "*/}
      {/*      BtnText="Rediger"*/}
      {/*    />*/}
      {/*    <ThemeBtn*/}
      {/*      onClick={() => {*/}
      {/*        navigate("/aktivitet-side");*/}
      {/*      }}*/}
      {/*      BtnClass="Theme_btn_primary "*/}
      {/*      BtnText="Se alle"*/}
      {/*    />*/}
      {/*  </div>*/}
      {/*  <div className="item-landing">*/}
      {/*    <h2 className="text-center card_heading">Sammendrag</h2>*/}
      {/*    <ThemeBtn*/}
      {/*      onClick={() => {*/}
      {/*        navigate("/rekkefølge");*/}
      {/*      }}*/}
      {/*      BtnClass="Theme_btn_primary "*/}
      {/*      BtnText="Salg historikk"*/}
      {/*    />*/}
      {/*    <ThemeBtn*/}
      {/*       onClick={() => {*/}
      {/*        navigate("/unike-koder");*/}
      {/*      }}*/}
      {/*      BtnClass="Theme_btn_primary "*/}
      {/*      BtnText="Unike koder"*/}
      {/*    />*/}
      {/*    <ThemeBtn*/}
      {/*      onClick={() => {*/}
      {/*        alert("No Google Analytics embedded");*/}
      {/*      }}*/}
      {/*      BtnClass="Theme_btn_primary "*/}
      {/*      BtnText="Besøksdata"*/}
      {/*    />*/}
      {/*  </div>*/}
      
      {/*  */}{/* <div className="item-landing">*/}{/*
      */}{/*    <h2 className="text-center card_heading">Bilder</h2>*/}{/*
      */}{/*    <ThemeBtn*/}{/*
      */}{/*      onClick={() => {*/}{/*
      */}{/*        navigate("/bilder");*/}{/*
      */}{/*      }}*/}{/*
      */}{/*      BtnClass="Theme_btn_primary "*/}{/*
      */}{/*      BtnText="Rediger bilder"*/}{/*
      */}{/*    />*/}{/*
      */}{/*  </div> */}
      {/*    </div>*/}
      {/*    <div className="body-landing">*/}
      {/*        <div className="item-landing">*/}
      {/*            <h2 className="text-center card_heading">Nettsiden</h2>*/}
      {/*            <ThemeBtn*/}
      {/*                onClick={() => {*/}
      {/*                    navigate("/søke");*/}
      {/*                }}*/}
      {/*                BtnClass="Theme_btn_primary "*/}
      {/*                BtnText="Kategori favoritter"*/}
      {/*            />*/}
      {/*            <ThemeBtn*/}
      {/*                onClick={() => {*/}
      {/*                    navigate("/aktivitet-side");*/}
      {/*                }}*/}
      {/*                BtnClass="Theme_btn_primary "*/}
      {/*                BtnText="⁠Gavetips favoritter"*/}
      {/*            />*/}

      {/*            <ThemeBtn*/}
      {/*                onClick={() => {*/}
      {/*                    navigate("/kuponger");*/}
      {/*                }}*/}
      {/*                BtnClass="Theme_btn_primary"*/}
      {/*                BtnText="Kuponger"*/}
      {/*            />*/}
      {/*        </div>*/}
      {/*        <div className="item-landing">*/}
      {/*            <h2 className="text-center card_heading">Bedriftskunder</h2>*/}

      {/*            <ThemeBtn*/}
      {/*                onClick={() => {*/}
      {/*                    navigate("/legge-til-bedriftskunde");*/}
      {/*                }}*/}
      {/*                BtnClass="Theme_btn_primary"*/}
      {/*                BtnText="Legg til"*/}
      {/*            />*/}



      {/*            <ThemeBtn*/}
      {/*                onClick={() => {*/}
      {/*                    navigate("/partner-dashbordet2");*/}
      {/*                }}*/}
      {/*                BtnClass="Theme_btn_primary"*/}
      {/*                BtnText="Redigere"*/}
      {/*            />*/}
               
      {/*        </div>*/}
      {/*        <div className="item-landing" >*/}
      {/*            <h2 className="text-center card_heading">Verktøy</h2>*/}

      {/*            */}{/*<ThemeBtn*/}
      {/*            */}{/*    onClick={() => {*/}
      {/*            */}{/*        navigate("/utility-dashbaord");*/}
      {/*            */}{/*    }}*/}
      {/*            */}{/*    BtnClass="Theme_btn_primary"*/}
      {/*            */}{/*    BtnText="Automatiser jobber"*/}
      {/*            */}{/*/>*/}



      {/*            <ThemeBtn*/}
      {/*                onClick={() => {*/}
      {/*                    navigate("/hangfire-jobber");*/}
      {/*                }}*/}
      {/*                BtnClass="Theme_btn_primary"*/}
      {/*                BtnText="Automatiser jobber"*/}
      {/*            />*/}

      {/*            <ThemeBtn*/}
      {/*                onClick={() => {*/}
      {/*                    navigate("search/EmailJobManager");*/}
      {/*                }}*/}
      {/*                BtnClass="Theme_btn_primary"*/}
      {/*                BtnText="E-posthistorikk"*/}
      {/*            />*/}



      {/*        </div>*/}
      {/*    </div>*/}
    </div>
  );
}

export default AdminLandingPage;